import { Component, OnInit } from '@angular/core';
// import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { LogService } from '../service/log.service';
import { BsModalRef } from 'ngx-bootstrap/modal';

export interface SourceModel {
    source: string,
    username: string
}

export interface ILogsModel {
    processstage: string,
    message: string,
    logtime: string,
    messagetype: string
}

@Component({
    selector: 'show-log-dialog',
    templateUrl: './show-log-dialog.component.html',
    styleUrls: ['./show-log-dialog.component.css']
})

export class ShowLogDialogComponent implements SourceModel, OnInit { 

    logList: ILogsModel[] = [];
    source: string;
    username: string;
    //processStages: string[] = [];
    logHeading: string;
    showLoader: boolean;
    noLogs: boolean;
    userAction: string;
    correlation_ID: string;

    constructor(private logService: LogService,
        private bsModalRef: BsModalRef) {     
    }

    ngOnInit(): void {
        try {
            this.setValues();
            this.invokeFetchLogsAPI()
        }
        catch (error) {
            console.log(error)
        }
    }

    setValues(): void {
        if(this.source == "predict") {
            this.userAction = "INSTANTPREDICTION"
            this.logHeading = "Instant Predict"
        }
        else if(this.source == "preprocess_new"){
            this.userAction = "PREPROCESS_NEW"
            this.logHeading = "Preprocess New"
        }
        else if(this.source == "training"){
            this.userAction = "TRAINING"
            this.logHeading = "Training"
        }
        else if(this.source == "preprocess_existing"){
            this.userAction = "PREPROCESS_EXISTING"
            this.logHeading = "Preprocess Existing"
        }
        else if(this.source == "excel_predict"){
            this.userAction = "EXCEL_PREDICTION"
            this.logHeading = "Excel Prediction"
        }
    }

    invokeFetchLogsAPI(): void {
        console.log(this.username)
        this.showLoader = true;
        this.noLogs = true;

        this.logService.fetchLogs(this.userAction, this.username).subscribe(data => {
            this.correlation_ID = data.correlationID
            this.logList = data.log_list
            this.showLoader = false;
            if(this.logList.length) {
                this.noLogs = false;
                // this.logList.forEach(item => {
                //     if(this.processStages.indexOf(item.processstage) < 0)
                //         this.processStages.push(item.processstage);
                // })
            }
        }, error => {
            this.showLoader = false;
            console.log(error)
        })
        
        //this.logList = this.hardCodedLog()
    }

    filteredLogList(stage): ILogsModel[] {
        let filterList = this.logList.filter(e => e.processstage == stage)
        return filterList;
    }

    closeModal() {
        this.bsModalRef.hide();
        // this.close();
    }

    // hardCodedLog() {
    //     this.showLoader = false
    //     this.noLogs = false
    //     let logs = [
    //         {
    //             "message": "Training in progress!!",
    //             "processstage": "Model Training",
    //             "logtime": "2022-07-18T11:57:00",
    //             "messagetype": "INFO"
    //         },
    //         {
    //             "message": "Consuming data for training...",
    //             "processstage": "Loading Data",
    //             "logtime": "2022-07-18T11:57:00",
    //             "messagetype": "ERROR"
    //         },
    //         {
    //             "message": "Consuming data for training...",
    //             "processstage": "Data processing",
    //             "logtime": "2022-07-18T11:57:00",
    //             "messagetype": "SUCCESS"
    //         },
    //         {
    //             "message": "Fetching required files for preparing training data ",
    //             "processstage": "Data processing",
    //             "logtime": "2022-07-18T11:57:00",
    //             "messagetype": "INFO"
    //         },
    //         {
    //             "message": "Training Started, In progress...",
    //             "processstage": "Data processing",
    //             "logtime": "2022-07-18T11:57:00",
    //             "messagetype": "INFO"
    //         },
    //         {
    //             "message": "Preprocessing in progress",
    //             "processstage": "Data preprocessing",
    //             "logtime": "2022-07-18T11:57:00",
    //             "messagetype": "INFO"
    //         },
    //         {
    //             "message": "Preprocessing completed",
    //             "processstage": "Data preprocessing",
    //             "logtime": "2022-07-18T11:57:00",
    //             "messagetype": "INFO"
    //         },
    //         {
    //             "message": "Model Training completed!!",
    //             "processstage": "Model Training",
    //             "logtime": "2022-07-18T11:57:00",
    //             "messagetype": "INFO"
    //         },
    //         {
    //             "message": "Model saving is in process",
    //             "processstage": "Model Dumping",
    //             "logtime": "2022-07-18T11:57:00",
    //             "messagetype": "INFO"
    //         },
    //         {
    //             "message": "Model saving completed successfully",
    //             "processstage": "Model Dumping",
    //             "logtime": "2022-07-18T11:57:00",
    //             "messagetype": "INFO"
    //         },
    //         {
    //             "message": "Model accuracy testing in progress",
    //             "processstage": "Accuracy Testing",
    //             "logtime": "2022-07-18T11:57:00",
    //             "messagetype": "INFO"
    //         },
    //         {
    //             "message": "Model accuracy testing successfully completed",
    //             "processstage": "Accuracy Testing",
    //             "logtime": "2022-07-18T11:57:00",
    //             "messagetype": "INFO"
    //         },
    //         {
    //             "message": "Storing model accuracy",
    //             "processstage": "Accuracy Testing",
    //             "logtime": "2022-07-18T11:57:00",
    //             "messagetype": "INFO"
    //         },
    //         {
    //             "message": "Data files cleaning in progress!!",
    //             "processstage": "Data Flushing",
    //             "logtime": "2022-07-18T11:57:00",
    //             "messagetype": "INFO"
    //         },
    //         {
    //             "message": "Training process completed",
    //             "processstage": "Training Ended",
    //             "logtime": "2022-07-18T11:57:00",
    //             "messagetype": "INFO"
    //         }
    //     ]
    //     return logs
    // }
}